import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import * as fileSaver from 'file-saver';

import { NomenclaturasService } from 'src/app/services/nomenclaturas/nomenclaturas.service';
import { CentrosCostoService } from 'src/app/services/centros-costo/centros-costo.service';
import { ClientesService } from 'src/app/services/clientes/clientes.service';
import { MedidasService } from 'src/app/services/medidas/medidas.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css'],
})
export class DocumentosComponent implements OnInit {
  file: any;

  // * Arreglo para los logs.
  arrayLog = [];

  // ? NgModel ¿para almacenar? la opción elegida.
  selectedDoc;

  // * Arreglo de documentos.
  documents = [
    'Nomenclatura',
    'Centros costo',
    'Clientes',
    'Facturas CXC',
    'Proveedores',
    'Facturas CXP',
    'Medidas',
    'Productos',
  ];

  // * Id de uploadfile
  uploadfile = document.getElementById('uploadfile');

  // * ids Local Storage
  userIdLS = localStorage.getItem('userId');
  userRoleIdLS = localStorage.getItem('userRoleId');
  userEmpresaId = localStorage.getItem('idEmpresa');

  constructor(
    private router: Router,
    private nomenclaturasService: NomenclaturasService,
    private centrosCostoService: CentrosCostoService,
    private clientesService: ClientesService,
    private medidasService: MedidasService,
    private productosService: ProductosService
  ) {}

  ngOnInit(): void {
    if (this.userEmpresaId === '') {
      this.router.navigate(['/empresas']);
    } else if (this.userIdLS != null) {
      console.log('idempresa: ', this.userEmpresaId);
    } else {
      // reedirigir a login
      this.router.navigate(['/login']);
    }
  }

  // * Subrutina para alimentar el log y desplegar la tarjeta.
  arrayLogPush(res = []): any {
    this.arrayLog.length = 0;
    this.arrayLog = [...res];
    if (this.arrayLog.length > 0) {
      $('.collapse').collapse('show');
    }
  }

  // * Pone el arrayLog en 0, el Log de eventos lo oculta y asigna el nombre y contenido por default al subir archivo
  resetArrayLogNCollapseNContent2ndStep(): any {
    this.arrayLog.length = 0;
    $('.collapse').collapse('hide');
    this.file = undefined;
    const fileU = document.getElementById('uploadfile');
    fileU.setAttribute('data-title', 'Arrastra o selecciona un archivo .xlsx');
  }
  reset2ndContentNArrayLog(value): any {
    console.log('value :>> ', value);
    switch (value) {
      case 'Nomenclatura':
        this.resetArrayLogNCollapseNContent2ndStep();
        break;
      case 'Centros costo':
        this.resetArrayLogNCollapseNContent2ndStep();
        break;
      case 'Clientes':
        this.resetArrayLogNCollapseNContent2ndStep();
        break;
      case 'Medidas':
        this.resetArrayLogNCollapseNContent2ndStep();
        break;
      case 'Productos':
        this.resetArrayLogNCollapseNContent2ndStep();
        break;
    }
  }

  // * Subrutina para descargar el documento en base al 'documento' seleccionado en el select>option
  downloadDocument(): any {
    if (this.selectedDoc == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Debes seleccionar el tipo de documento',
        returnInputValueOnDeny: false,
      });
    } else {
      switch (this.selectedDoc) {
        case 'Nomenclatura':
          this.downloadNomenclaturasDocument();
          break;
        case 'Centros costo':
          this.downloadCentrosCostoDocument();
          break;
        case 'Clientes':
          this.downloadClientesDocument();
          break;
        case 'Medidas':
          this.downloadMedidasDocument();
          break;
        case 'Productos':
          this.downloadProductosDocument();
          break;
      }
    }
  }

  // * Subrutina para subir el documento en base al 'documento' seleccionado en el select>option
  postDocument(): any {
    if (this.selectedDoc == null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Debes seleccionar el tipo de documento',
        returnInputValueOnDeny: false,
      });
    } else {
      switch (this.selectedDoc) {
        case 'Nomenclatura':
          this.postNomenclaturasDocument();
          break;
        case 'Centros costo':
          this.postCentrosCostoDocument();
          break;
        case 'Clientes':
          this.postClientesDocument();
          break;
        case 'Medidas':
          this.postMedidasDocument();
          break;
        case 'Productos':
          this.postProductosDocument();
          break;
      }
    }
  }

  // * Subrutina para validar el evento del documento y añadir el nombre a la vista.
  selectOrUploadFile(event?, flag?: boolean): any {
    if (event.target.files.length > 0) {
      const cfile = event.target.files[0];
      this.file = cfile;
      const reader = new FileReader();
      reader.onload = () => {
        const fileName = event.target.files[0].name;
        const file = document.getElementById('uploadfile');
        file.setAttribute('data-title', fileName);
      };
      reader.readAsDataURL(cfile);
    }
  }

  // ! Subrutinas de descarga y carga de documentos.

  // ? **********************
  // * Subrutina para descargar el documento nomenclaturas a llenar.
  downloadNomenclaturasDocument(): any {
    this.nomenclaturasService.downloadDocument().subscribe(
      (res) => {
        const blob = new Blob([res], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
        });
        fileSaver.saveAs(blob, 'nomenclaturas.xlsx');
        console.log(res);
        this.arrayLogPush(['Archivo "Nomenclaturas" descargado.']);
        setTimeout(() => {
          this.resetArrayLogNCollapseNContent2ndStep();
        }, 10000);
      },
      (err) => {
        if (err) {
          this.arrayLogPush(['El archivo "Nomenclaturas" no existe.']);
          setTimeout(() => {
            this.resetArrayLogNCollapseNContent2ndStep();
          }, 10000);
        }
      }
    );
  }

  // * Subrutina para enviar el documento medidas a la base de datos.
  postNomenclaturasDocument(): any {
    const formData = new FormData();
    formData.append('uploadfile', this.file);
    this.nomenclaturasService
      .postDocument(formData, this.userEmpresaId)
      .subscribe(
        (res) => {
          console.log('res :>> ', res);
          this.arrayLogPush(res);
        }
        // res => console.log(res)
      );
  }

  // ? **********************
  // * Subrutina para descargar el documento Centros costo a llenar.
  downloadCentrosCostoDocument(): any {
    this.centrosCostoService.downloadDocument().subscribe(
      (res) => {
        const blob = new Blob([res], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
        });
        fileSaver.saveAs(blob, 'nomenclaturas.xlsx');
        console.log(res);
        this.arrayLogPush(['Archivo "Centros costo" descargado.']);
        setTimeout(() => {
          this.resetArrayLogNCollapseNContent2ndStep();
        }, 10000);
      },
      (err) => {
        if (err) {
          this.arrayLogPush(['El archivo "Centros costo" no existe.']);
          setTimeout(() => {
            this.resetArrayLogNCollapseNContent2ndStep();
          }, 10000);
        }
      }
    );
  }

  // * Subrutina para enviar el documento Centros costo a la base de datos.
  postCentrosCostoDocument(): any {
    const formData = new FormData();
    formData.append('uploadfile', this.file);
    this.centrosCostoService
      .postDocument(formData, this.userEmpresaId)
      .subscribe(
        (res) => this.arrayLogPush(res)
        // res => console.log(res)
      );
  }

  // ? **********************
  // * Subrutina para descargar el documento Centros costo a llenar.
  downloadClientesDocument(): any {
    this.clientesService.downloadDocument().subscribe(
      (res) => {
        const blob = new Blob([res], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
        });
        fileSaver.saveAs(blob, 'nomenclaturas.xlsx');
        console.log(res);
        this.arrayLogPush(['Archivo "Clientes" descargado.']);
        setTimeout(() => {
          this.resetArrayLogNCollapseNContent2ndStep();
        }, 10000);
      },
      (err) => {
        if (err) {
          this.arrayLogPush(['El archivo "Clientes" no existe.']);
          setTimeout(() => {
            this.resetArrayLogNCollapseNContent2ndStep();
          }, 10000);
        }
      }
    );
  }

  // * Subrutina para enviar el documento Centros costo a la base de datos.
  postClientesDocument(): any {
    const formData = new FormData();
    formData.append('uploadfile', this.file);
    this.clientesService.postDocument(formData, this.userEmpresaId).subscribe(
      (res) => this.arrayLogPush(res)
      // res => console.log(res)
    );
  }

  // ? **********************
  // * Subrutina para descargar el documento medidas a llenar.
  downloadMedidasDocument(): any {
    this.medidasService.downloadDocument().subscribe(
      (res) => {
        const blob = new Blob([res], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
        });
        fileSaver.saveAs(blob, 'medidas.xlsx');
        console.log(res);
        this.arrayLogPush(['Archivo "Medidas" descargado.']);
        setTimeout(() => {
          this.resetArrayLogNCollapseNContent2ndStep();
        }, 10000);
      },
      (err) => {
        if (err) {
          this.arrayLogPush(['El archivo "Medidas" no existe.']);
          setTimeout(() => {
            this.resetArrayLogNCollapseNContent2ndStep();
          }, 10000);
        }
      }
    );
  }

  // * Subrutina para enviar el documento medidas a la base de datos.
  postMedidasDocument(): any {
    const formData = new FormData();
    formData.append('uploadfile', this.file);
    this.medidasService.postDocument(formData, this.userEmpresaId).subscribe(
      (res) => this.arrayLogPush(res)
      // res => console.log(res)
    );
  }

  // ? **********************
  // * Subrutina para descargar el documento productos a llenar.
  downloadProductosDocument(): any {
    this.productosService.downloadDocument().subscribe(
      (res) => {
        const blob = new Blob([res], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
        });
        fileSaver.saveAs(blob, 'productos.xlsx');
        console.log(res);
        this.arrayLogPush(['Archivo "Productos" descargado.']);
        setTimeout(() => {
          this.resetArrayLogNCollapseNContent2ndStep();
        }, 10000);
      },
      (err) => {
        if (err) {
          this.arrayLogPush(['El archivo "Productos" no existe.']);
          setTimeout(() => {
            this.resetArrayLogNCollapseNContent2ndStep();
          }, 10000);
        }
      }
    );
  }

  // * Subrutina para enviar el documento productos a la base de datos.
  postProductosDocument(): any {
    const formData = new FormData();
    formData.append('uploadfile', this.file);
    this.productosService
      .postDocument(formData, this.userEmpresaId)
      .subscribe((res) => this.arrayLogPush(res));
  }
}
